import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import Loader from "../Loader";

import LightGallery from 'lightgallery/react';

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const EcommerceGallery = () => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const location = useLocation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true)

    const onInit = (detail) => {
        if (detail) {
            detail.instance.refresh(); // Optional: Refresh to avoid issues
        }
    };
    const onBeforeSlide = (detail) => {
        const { index, prevIndex } = detail;
        console.log(index, prevIndex);
    };

  const fetchPagedata = useCallback(async () => {
    let apiUrl = '';
    if (location.pathname === '/') {
        apiUrl = apiBaseUrl+`portfolio?is_home=1&cat=e_commerce`;
    } else {
        apiUrl = apiBaseUrl+`portfolio?cat=e_commerce`;
    }    
    return axios.get(apiUrl).then((res) => {
      setData(res.data);
    });
  },[]);  

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchPagedata();
      setLoading(false);
    }, 1000); // 1 seconds
    return () => clearTimeout(timer);
  }, [fetchPagedata]);


    return (
        <>
            {/* 
            <div className="text-center p-5">
                <div className="spinner-border text-primary" />
            </div>      
            */}  
        { loading ? 
            <Loader />
            :
            <LightGallery
                elementClassNames="row photo-gallery-row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4"
                key="e_commerce"
                onInit={onInit}
                speed={500}
                plugins={[lgThumbnail, lgZoom]}
            >
            {data.map((item, index) => {
                return (
                    <a className='col-sm-4' href={item?.image} key={index}>
                        <img className="img-fluid" alt={item?.name} src={item?.image} />
                    </a>
                )
            })}
            </LightGallery>
        }
        </>
    )
}

export default EcommerceGallery